import { base44 } from '@/api/base44Client';

/**
 * Creates a SupportEnquiry record with a sequential MR-#### reference.
 * Delegates to the createSupportEnquiry backend function, which runs as the
 * service role to derive the next number (public callers can't read records)
 * and creates the ticket.
 */
export async function createSupportEnquiry(payload) {
  const res = await base44.functions.invoke('createSupportEnquiry', payload);
  const data = res?.data || res;
  if (data?.error) throw new Error(data.error);
  return data;
}

export const ENQUIRY_CATEGORIES = [
  { value: 'booking_amendment_cancellation', label: 'Booking Amendment / Cancellation' },
  { value: 'hardware_sim_rigs', label: 'Hardware / Sim Rigs' },
  { value: 'corporate_group_events', label: 'Corporate & Group Events' },
  { value: 'general_support', label: 'General Support' },
];

export const ENQUIRY_STATUS = {
  New: { label: 'NEW', className: 'text-primary border-primary/40 bg-primary/10' },
  Open: { label: 'OPEN', className: 'text-yellow-400 border-yellow-400/40 bg-yellow-400/10' },
  Resolved: { label: 'RESOLVED', className: 'text-green-400 border-green-400/40 bg-green-400/10' },
};

export function categoryLabel(key) {
  return ENQUIRY_CATEGORIES.find((c) => c.value === key)?.label || key || '—';
}